module.exports = __webpack_public_path__ + "img/padlock-selected.75928189.png";